export const POST_PURCHASE_STATE = 'postPurchase';
export const MANAGEABLE_LOAN_STATE = 'manageableLoan';
export const PAID_OFF_LOAN_STATE = 'paidOffLoan';
export const TEST = 'test';
export const TRANSACTION_HISTORY_CARD_ROW_LENGTH = 3;

export const Analytics = {
  TEAM_NAME: 'cltv-oem',
  PROJECT_NAME: 'my-cars',
};

export const PaymentMethodType = {
  SAVING: 'Savings',
  CHECKING: 'Checking',
};

export const PaymentEligibilityTypes = {
  PAY_CURRENT_DUE: 'PAY_CURRENT_DUE',
  ONE_TIME_PAYMENT: 'ONE_TIME_PAYMENT',
  AUTO_PAYMENT: 'AUTO_PAYMENT',
  ALL_PAYMENTS: 'ALL_PAYMENTS',
};

export const AmountDueType = {
  OTHER: 'other',
  MINIMUM: 'minimum',
};

export const Routes = {
  MY_CARVANA_ROUTE: '/my-carvana/vehicle/',
  TRANSACTION_HISTORY: '/loan-detail/transaction-history/',
};

export const ProgressBarColors = {
  pastDue: {
    foregroundColor: '#122946',
    backgroundFontColor: '#122946',
  },
};
